var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-form"},[(_vm.title)?_c('c-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"c-form-content"},[_vm._t("default")],2),(_vm.$slots.button)?_c('div',{staticClass:"flex-center c-form-button"},[_vm._t("button")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }